import { useEffect } from 'react';
import analytics from 'service/analytics';
import styles from './index.module.sass';
import { CHANGE_CURRENT_PAGE, PAGE_STATS, useAppContext } from 'use-app';
import { StatsContent } from './stats-content';

const Stats = () => {
  const { dispatch: appDispatch } = useAppContext();
  useEffect(() => {
    analytics.statsPageView();
  }, []);

  useEffect(() => {
    appDispatch({
      type: CHANGE_CURRENT_PAGE,
      payload: PAGE_STATS,
    });
  }, [appDispatch]);

  return (
    <div className={styles.main}>
      <div className={styles.title}>消費統計</div>
      <div className={styles.desc} style={{ marginBottom: 20 }}>
        您的消費統計最多將有 2 天入帳時間差
      </div>
      <StatsContent />
    </div>
  );
};

export default Stats;
